import { Box, DialogContent, Stack, Typography } from '@mui/material';
import { ButtonComponent } from '@watter/shared-components';
import { useTranslation } from 'react-i18next';
import HeaterIcon from '../icons/heater-icon';
import { NoInternetModalUI } from './remove-heater-style';

type IDeleteNotificationPopupProps = {
    acceptHandler: () => void;
    rejectHandler: () => void;
    open: boolean;
};

const RemoveHeaterPopup = ({ acceptHandler, rejectHandler, open }: IDeleteNotificationPopupProps) => {
    const { t } = useTranslation();
    const closePopup = () => {
        rejectHandler();
    };
    return (
        <NoInternetModalUI
            open={open}
            onClose={closePopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="changePassword"
        >
            <DialogContent>
                <Box height="100%" width="100%" justifyContent="center" display="flex" flexDirection="column">
                    <Box sx={{ alignSelf: 'center' }}>
                        <HeaterIcon />
                    </Box>
                    <Typography variant="h5" mb={0.6} className="header" textAlign="center" mt={2}>
                        {`${t('remove_heater_from_account')}?`}
                    </Typography>
                    <Typography variant="subtitle1" mb={1.5} className="header" textAlign="center">
                        {`${t('remove_heater_from_account_msg')}`}
                    </Typography>
                    <Stack rowGap={2} className="actionItems" flexDirection="row" justifyContent="center" mt={1}>
                        <Box className="cstBtnWrapper">
                            <ButtonComponent
                                size="medium"
                                variant="contained"
                                fullWidth
                                buttonName={t('cancel')}
                                className="cstBtn2"
                                onClick={rejectHandler}
                            />
                        </Box>
                        <Box className="cstBtnWrapper">
                            <ButtonComponent
                                size="medium"
                                variant="contained"
                                fullWidth
                                buttonName={t('remove')}
                                className="cstBtn"
                                onClick={acceptHandler}
                            />
                        </Box>
                    </Stack>
                </Box>
            </DialogContent>
        </NoInternetModalUI>
    );
};
export { RemoveHeaterPopup };
